export class GlobalCssVars {
  public headerHeight: number
  public radius5: string
  public radius3: string
  public radius7: string
}

export const globalCssVars = new GlobalCssVars()
